import { set } from '@/utils/vuex'

export default {
  // Timers
  setCurrentTimestamp: set('currentTimestamp'),
  setFetchedTimestamp: set('fetchedTimestamp'),
  setIntervalId: set('intervalId'),

  // Data
  setLoading: set('loading'),

  setHeaders: set('headers'),

  setArea: set('area'),

  setCustomers: set('customers'),
  setSearchText: set('searchText'),
  setSearchResults: set('searchResults'),

  setSelectedIDs: set('selectedIDs'),
  selectID (state, { index = -1, id }) {
    if (index < 0) {
      state.selectedIDs.push(id)
      return
    }
    state.selectedIDs.splice(index, 0, id)
  },
  deSelectID (state, index) {
    state.selectedIDs.splice(index, 1)
  },

  setCaseNumberInput: set('caseNumberInput'),
  setOilSupplyInput: set('oilSupplyInput')
}
